import { getCommonInfo, openUrlOutAPP } from '@/assistant/JSBridge'

export const getVersion = () => {
  let re = /OS ((\d{1,2})_\d{1,2}||(\d{1,2})_\d{1,2}_\d{1,2}) like Mac OS X/i

  let result = re.exec(window.navigator.userAgent)
  let ios_ver = result && result[1] && result[1].substr(0, 2)
  return parseInt(ios_ver)
}

export const isIphoneX = () => {
  return /iphone/gi.test(window.navigator.userAgent) && (screen.height === 812 && screen.width === 375)
}

// 当前请求域名封装url
export const buildUrl = (path) => {
  if (path.indexOf('://') > -1) {
    return path
  }
  let url = location.protocol + '//' + location.host + path
  // let url = location.protocol + '//192.168.66.228:6001' + path

  return url
}

// 安装证书
export const gotoInstallCertificate = () => {
  return getCommonInfo([])
    .then((res) => {
      let auth = res['IDFA'] + '|' + res['UUID']
      let url = buildUrl('/profile/profile_service.mobileconfig?tadx=' + encodeURIComponent(auth))
      openUrlOutAPP(url)
    })
}

export const gotoManager = () => {
  return getCommonInfo([])
    .then((res) => {
      let auth = res['IDFA'] + '|' + res['UUID']
      let url = buildUrl('/profile/manager?tadx=' + encodeURIComponent(auth))
      openUrlOutAPP(url)
    })
}

// 获取APPID
export const getAppID = () => {
  getCommonInfo([]).then((result) => {
    let bundleID = result['BundleID']
    switch (bundleID) {
      case 'com.hb.zhushou':
        $storage.set('APP_ID', 'wxdeb3012af0ab83e2')
        break
      case 'com.yi.team':
        $storage.set('APP_ID', 'wx06bb91f8330dcf65')
        break
      default:
        $storage.set('APP_ID', 'wx71624212ca0b2f6c')
    }
  })
}

// 获取UUID
export const getUUID = () => {
  getCommonInfo([]).then((result) => {
    return result['UUID']
  })
}
